import { ToastContainer } from "react-toastify"
import RoutesApp from "./routes/RoutesApp"

function App() {
  return (
    <div className="w-screen">
       <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }}
      />
      <RoutesApp />
    </div>
  )
}

export default App
